<template>
    <el-row class="card-deal-params">
        <ul class="deal-params-menu tab-submenu">
            <li
                v-for="card in paramCards"
                :key="card.component"
                :class="{ active: currentParamCard === card.component }"
                @click="currentParamCard = card.component"
            >
                <span>
                    {{ card.title }}
                </span>
            </li>
        </ul>
        <el-col>
            <keep-alive>
                <component :is="currentParamCard" />
            </keep-alive>
        </el-col>
    </el-row>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck, faCheckSquare, faEye, faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { faSquare } from '@fortawesome/free-regular-svg-icons';
import '@/assets/styles/card-complex.scss';
import '@/assets/styles/card.scss';
import KeyInfo from '@/views/crm/deals/card-blocks/KeyInfo';
import Measurement from '@/views/crm/deals/card-blocks/Measurement';
import Production from '@/views/crm/deals/card-blocks/Production';
import Contract from '@/views/crm/deals/card-blocks/Contract';
import Installation from '@/views/crm/deals/card-blocks/Installation';
import Complaint from '@/views/crm/deals/card-blocks/Complaint';
import Contact from '@/views/crm/deals/card-blocks/Contact';
import Tasks from '@/components/Tasks';
import Events from '@/components/events/Events';

library.add(faCheck, faCheckSquare, faSquare, faEye, faPaperclip);

export default {
    name: 'MainInfo',
    props: {
        dealId: {
            type: [String, Number],
            default: 0
        }
    },
    data() {
        return {
            isDarkenColumn: false,
            currentParamCard: 'contact',
            paramCards: [
                { component: 'contact', title: 'Конт' },
                { component: 'measurement', title: 'Замер' },
                { component: 'contract', title: 'Дог' },
                { component: 'production', title: 'Пр-во' },
                { component: 'installation', title: 'Монт' },
                { component: 'complaint', title: 'Рекл' }
            ],
            statusParamsCardTable: [
                'contact', //Контакт установлен –> Контакт
                'measurement', //Замер назначен -> Замер
                'measurement', //Замер был, следить -> Замер
                'contract', //Договор -> Договор
                'contract', //Доставка -> Договор
                'installation', //Монтаж назначен -> Монтаж
                'installation', //Монтаж выполнен -> Монтаж
                'contract', //Успешно завершено -> Договор
                'complaint', //Рекламация Открыта -> Рекламация
                'complaint', //Рекламация Закрыта -> Рекламация
                'contract', //Договор Фиксация -> Договор
                'contact', //Отложенный спрос -> Контакт
                'contact', //Закрыто и не реализовано -> Контакт
                'contact', //Отказ от замера -> Контакт
                'measurement' //Тех отказ -> Замер
            ]
        };
    },
    components: {
        Contract,
        KeyInfo,
        Measurement,
        Production,
        Installation,
        Complaint,
        Contact,
        Tasks,
        Events
    },
    computed: {
        deal() {
            return this.$store.state.deals.current;
        },
        status_id() {
            return this.$store.state.deals.current.status_id;
        }
    },
    methods: {
        darkenColumn(value) {
            this.isDarkenColumn = value;
        }
    },
    watch: {
        status_id(newValue) {
            if (newValue) {
                this.currentParamCard = this.statusParamsCardTable[newValue - 1];
            }
        }
    }
};
</script>
